import Catalog from '//secretlab.sg/cdn/shop/t/637/assets/catalog.js?v=128450232615949517361669130641'


Catalog({
    container: '.valorantesports-catalogue'
    , catalog_option: '.valorantesports-option'
    , catalog_active_variant: 'masters23'
    
    , onInit: () => document.querySelector('.catalogue-chairs:not(.loaded)')?.classList.add('loaded')
    , onSelect: () =>  $.drawer?.close($('.drawer'))

    , activeElementSelector: (variant, group) => `.logo-${variant}
                                                  , .chair-${variant}
                                                  , .title-${variant}
                                                  , .content-${variant}
                                                  , *[data-variant=${variant}] 
                                                  ${ !!group ? `, .group[data-variant=${group}]` : ''}
                                                  `
});

whenAvailable("$", function () {
  $(function(){
    console.log("here?")
    function initParallax() {
      const windowWidth = $(window).width();
      //add parallex in ipad and desktop size
      if (windowWidth > 991) {
        $('.parallax-init').addClass('parallax-obj');
      } else {
        $('.parallax-init').removeClass('parallax-obj');
        $('.parallax-init').css("transform","");
      }
    }
    window.onresize = () => {initParallax()}
    initParallax();
  });
});